import { createUseStyles } from 'react-jss';

import colors from "../../../utils/colors";
import { ProductLineSectionType } from "../../../utils/ProductLinesHelper";






var styles = {
  productLineSection: function productLineSection(_ref) {var cartItemsQuantity = _ref.cartItemsQuantity;return {
      marginBottom: '2rem',
      paddingBottom: cartItemsQuantity === 0 ? '2rem' : 0,
      borderBottom: cartItemsQuantity === 0 ? "0.1rem solid ".concat(colors.neutral[300]) : 'none'
    };},
  addButton: {
    textTransform: 'uppercase',
    paddingLeft: 0
  },
  productLineBlock: function productLineBlock(_ref2) {var productLineSection = _ref2.productLineSection;return {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: productLineSection === ProductLineSectionType.ANCILLARY ? 'flex-start' : 'center',
      marginBottom: '1.5rem'
    };},
  comparePortfoliosButton: {
    textTransform: 'uppercase'
  },
  pLineButton: {
    padding: 0,
    fontWeight: 700,
    textAlign: 'left',
    minWidth: 'auto',
    '&:hover': {
      color: colors.blue[600],
      textDecoration: 'none'
    }
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map